import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";

interface props {
  reported: any;
  appear: any;
}

export default function GoogleAds({ reported, appear }: props) {
  const diff = reported - appear;
  const percent = appear > 0 ? ((diff / appear) * 100).toFixed(1) : "0";
  return (
    <Box width="100%">
      <Stack
        direction="row"
        alignItems="flex-start"
        sx={{
          "@media (max-width:1600px)": {
            flexDirection: "column",
          },
        }}
      >
        <Box width="100%" p={1} border="1px solid #E0E0E0" borderRadius="8px">
          <Box>
            {/* Header */}
            <Stack direction="row" justifyContent="space-between">
              <Typography
                variant="subtitle2"
                color="text.secondary"
                mb={1}
                fontSize="16px"
              >
                Gap in Google Ads
              </Typography>
              <img
                src="/GoogleAds.png"
                alt="Google Ads"
                width={24}
                height={24}
                style={{ objectFit: "contain" }}
              />
            </Stack>

            {/* Difference */}
            <Stack direction="row" alignItems="baseline" spacing={1}>
              <Typography variant="h5" fontWeight={700}>
                {diff}
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {percent}%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Difference
              </Typography>
            </Stack>

            {/* Details */}
            <Typography
              variant="body2"
              mt={1}
              color="text.secondary"
              fontSize="10px"
            >
              {reported} FTDs Reported / {appear} FTDs on platform
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
